import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'm-calibration-item',
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: true,
  host: {
    '[style.background]': 'mColor',
    class: 'm-calibration-item'
  }
})
export class MCalibrationItemComponent {
  @Input() mColor = '#e8e8e8';
}
